module.exports = __webpack_public_path__ + "img/ic_loading.3c325f60.svg";